import { useTheme } from '@mui/material';
import { SparkLineChart } from '@mui/x-charts/SparkLineChart';

import { SparklineProps } from './Sparkline.types';

/**
 * 24-point trend line for a KPI tile or a table cell.
 *
 * Renders nothing below two points: a one-point "trend" is a dot that reads as a real shape.
 */
export const Sparkline = ({ data, color, height = 28, width, area = false }: SparklineProps): JSX.Element | null => {
  const { palette } = useTheme();

  if (data.length < 2) {
    return null;
  }

  return (
    <SparkLineChart
      data={data}
      height={height}
      {...(width ? { width } : {})}
      colors={[color ?? palette.chart.series[0]]}
      area={area}
      showTooltip={false}
      showHighlight={false}
      margin={{ top: 2, bottom: 2, left: 0, right: 0 }}
    />
  );
};
